import { registerMobstat } from 'utils/piwik';

const eventService = {
  timeMeter: {},
  'ap-001': (value) => {
    try {
      registerMobstat(
        {
          id: 'ap-001',
          name: 'prepaymentLineId排查',
        },
        [
          {
            l: 'prepaymentLineId排查',
            v: value,
          },
        ]
      );
    } catch (e) {}
  },
  'ap-00000110': () => {
    try {
      registerMobstat(
        {
          id: 'ap-00000110',
          name: '对公支付单复制-使用次数',
        },
        [
          {
            l: '操作',
            v: '点击复制按钮',
          },
        ]
      );
    } catch (e) {}
  },
  'ap-00000115': (value) => {
    try {
      registerMobstat(
        {
          id: 'ap-00000115',
          name: '对公支付单复制-付款行数量',
        },
        [
          {
            l: '付款行数量',
            v: value.lineNum,
          },
        ]
      );
    } catch (e) {}
  },
  'ap-00000120': (value) => {
    try {
      registerMobstat(
        {
          id: 'ap-00000120',
          name: '批量分摊付款行数量',
        },
        [
          {
            l: '付款行数量',
            v: value.lineNum,
          },
        ]
      );
    } catch (e) {}
  },
  'ap-00000130': (value) => {
    try {
      registerMobstat(
        {
          id: 'ap-00000130',
          name: '批量添加发票至付款行',
        },
        [
          {
            l: '发票数量',
            v: value.receiptNum,
          },
          {
            l: '付款行数',
            v: value.lineNum,
          },
          {
            l: '导入成功率',
            v: value.successRate,
          },
          {
            l: '报错内容',
            v: value.errorInfo,
          },
        ]
      );
    } catch (e) {}
  },
  'ap-00000140': (value) => {
    try {
      registerMobstat(
        {
          id: 'ap-00000140',
          name: '账本去报销对公支付单',
        },
        [
          {
            l: '使用功能',
            v: value.isHistoryReport ? '复制历史单据' : '直接新建单据',
          },
          {
            l: '付款行数',
            v: value.lineNum,
          },
        ]
      );
    } catch (e) {}
  },
  'ap-00000170': (value) => {
    const arr = ['去付款', '去核销', '后补发票', '后补合同', '退款'];
    try {
      registerMobstat(
        {
          id: 'ap-00000170',
          name: '对公-未结业务明细-列表功能使用情况',
        },
        [
          {
            l: '操作',
            v: arr[value],
          },
        ]
      );
    } catch (e) {}
  },
};

export default eventService;
